// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span[data-v-971966da]{display:inline-block;border-radius:var(--size);width:var(--size);height:var(--size);background-color:var(--color)}", ""]);
// Exports
module.exports = exports;
